import React, { useState, useEffect, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { updateUser, getUserById } from '../../API/Api';
import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../App';
import { toast } from 'react-toastify';
import { getCompanyDetails } from '../../API/Api';

function AbacusAsiaWealthAgreementModal() {
  const [open, setOpen] = useState(false);
  const [userDetails, setUserDetails] = useState();

  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);

  useEffect(() => {
    const fetchData = async () => {
      const userDetails = (await getUserById(decodedToken._id)).data;
      console.log(userDetails?.abacusAsiaWealthAgreed);
      console.log('userDetails.abacusAsiaWealthAgreed');
      console.log('userDetails');
      const companyData = await getCompanyDetails('company');
      if (!companyData.data.trial) {
        return;
      }

      if (userDetails?.abacusAsiaWealthAgreed) {
        return;
      }

      setUserDetails(userDetails);
      setOpen(true);
    };

    fetchData().catch(e => console.error('Error fetching user details'));
  }, []);

  const handleAgree = async (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;

    console.log('AbacusAsiaWealth Agreement accepted');
    try {
      await updateUser({
        ...userDetails,
        abacusAsiaWealthAgreed: true,
      });
    } catch (e) {
      console.log(e);
      toast.error('Something went wrong... contact admin.');
    }

    setOpen(false);
  };

  return (
    <div className=''>
      <Dialog open={open} onClose={handleAgree} disableEscapeKeyDown fullWidth maxWidth='md'>
        <DialogTitle>
          {' '}
          <strong> FREE TRIAL TERMS OF USE </strong>{' '}
        </DialogTitle>
        <DialogContent>
          <div className='bg-white overflow-auto'>
            {/* Introduction */}
            <div className='mb-4'>
              <p className='mb-4 bold'>
                These Free Trial Terms of Use (<span className='font-semibold'>"Terms"</span>) govern your access to and
                use of the iCOMPASS software (<span className='font-semibold'>"Platform"</span>) on a free trial basis,
                provided by
                <span className='font-semibold'> iCOMPASS Pte. Ltd.</span>(
                <span className='font-semibold'>"Company"</span>, <span className='font-semibold'>"we"</span>,
                <span className='font-semibold'>"us"</span>, or <span className='font-semibold'>"our"</span>). By
                registering for and accessing the Platform on a trial basis, you (
                <span className='font-semibold'>"User"</span>,<span className='font-semibold'>"you"</span>, or{' '}
                <span className='font-semibold'>"your"</span>) agree to be bound by these Terms.
              </p>
              <p className='bold'>If you do not agree to these Terms, you may not access or use the Platform.</p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 1 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>1. Trial Term and Access</h2>
              <p className='mb-3 bold'>
                1.1 You are granted a non-exclusive, non-transferable, limited right to access and use the Platform for
                evaluation purposes for a period of <span className='font-semibold'>14 days</span>, starting from the
                date of trial activation (<span className='font-semibold'>"Trial Period"</span>).
              </p>
              <p className='bold'>
                1.2 The Platform may be accessed via web browser on a desktop, with access granted to designated users.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 2 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>2. Scope and Limitations</h2>
              <p className='mb-3 bold'>
                2.1 The free trial may include only a subset of the Platform's full features, and may be subject to
                limitations on data volume, users, or usage.
              </p>
              <p className='mb-3 bold'>
                2.2 You shall not use the Platform for any commercial purpose beyond internal evaluation.
              </p>
              <p className='mb-3 bold'>2.3 You agree not to, and shall not permit others to:</p>
              <ul className='list-disc pl-10 mb-4 bold space-y-2'>
                <li>
                  Reverse-engineer, decompile, disassemble, or attempt to access the source code of the
                  <span className='font-semibold'> Platform</span>;
                </li>
                <li>Modify, adapt, copy, or create derivative works based on the Platform or any part of it;</li>
                <li>Interfere with or disrupt the Platform's operation, security, or accesscontrols;</li>
                <li>Use automated tools (e.g., bots or scraping software) to extract data; or</li>
                <li>
                  Use the Platform in any way that infringes intellectual property rights or violates applicable laws.
                </li>
              </ul>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 3 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>3. No Charges During Trial</h2>
              <p className='mb-3 bold'>3.1 No payment is required for use of the Platform during the Trial Period.</p>
              <p className='bold'>
                3.2 After the Trial Period ends, your access may be automatically disabled unless you enter into a
                separate subscription agreement.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 4 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>4. Data Handling</h2>
              <p className='bold'>
                4.1 Any data input or generated during the Trial Period may be deleted after{' '}
                <span className='font-semibold'>[30] days</span> unless you convert to a paid subscription.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 5 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>5. Termination</h2>
              <p className='mb-3 bold'>
                5.1 We may terminate or suspend your access to the Platform at any time, with or without cause, during
                the Trial Period.
              </p>
              <p className='bold'>5.2 You may discontinue your trial at any time by notifying us.</p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 6 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>6. Confidentiality</h2>
              <p className='bold'>
                6.1 The Platform and all related components are our confidential information. You agree not to disclose
                any performance, feedback, or feature information to any third party without our prior written consent.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 7 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>7. Disclaimer of Warranties</h2>
              <p className='mb-3 bold'>
                7.1 The Platform is provided "as is" and "as available" during the Trial Period.
              </p>
              <p className='bold'>
                7.2 We disclaim all warranties, express or implied, including merchantability, fitness for a particular
                purpose, and non-infringement.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 8 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>8. Limitation of Liability</h2>
              <p className='bold'>
                8.1 To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental,
                special, or consequential damages arising out of or related to your use of the Platform during the Trial
                Period.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 9 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>9. Governing Law</h2>
              <p className='bold'>
                9.1 These Terms shall be governed by and construed in accordance with the laws of Singapore. Any dispute
                shall be subject to the exclusive jurisdiction of the courts of Singapore.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Section 10 */}
            <div className='mb-4'>
              <h2 className='text-xl font-bold text-gray-800 mb-4'>10. General</h2>
              <p className='mb-3 bold'>
                10.1 These Terms constitute the entire agreement between you and us regarding the free trial use of the
                Platform.
              </p>
              <p className='bold'>
                10.2 If any provision is found unenforceable, the remaining provisions shall remain in full force.
              </p>
            </div>

            <div className='border-t border-gray-200 my-4'></div>

            {/* Acknowledgment */}
            <div className='mb-4'>
              <p className='bold font-semibold'>
                By clicking "I Agree" or accessing the Platform, you acknowledge that you have read, understood, and
                agree to these Free Trial Terms of Use.
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            onClick={handleAgree}
            className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'
          >
            I Agree
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AbacusAsiaWealthAgreementModal;
